import axios from "./userInstance"
import { Permission } from "@/types/role"

export default async (page = 1, size = 100) => {
  try {
    const response = await axios(`/permissions/`)
    return response.data
  } catch (error) {
    return [] as Permission[]
  }
}
